import React, { useState, useEffect } from 'react';
import { Overlay } from '@ds/ui';

interface PageData {
  vendorName: string;
  appName: string;
  revision: string;
}

interface FooterProps {
  style?: React.CSSProperties;
}

export const Footer: React.FC<FooterProps> = ({ style }) => {
  const [pageData, setPageData] = useState<PageData>({
    vendorName: 'Loading...',
    appName: 'Loading...',
    revision: 'Loading...'
  });

  useEffect(() => {
    const getLayoutInfo = async () => {
      try {
        const response = await fetch('Admin/Home/GetLayoutInfo');
        const data = await response.json();
        setPageData({
          vendorName: data.userInfo.vendorName,
          appName: data.userInfo.appName,
          revision: data.userInfo.revision
        });
      } catch (error) {
        console.error('Error fetching layout info:', error);
      }
    };

    getLayoutInfo();
  }, []);

  return (
    <div style={style}>
      <Overlay.Footer>
        <div
          style={{
            background: 'var(--Alias-Background-bgColorDefault, #FFF)',
            width: '100%',
            height: '4.5rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p className="text-sm text-gray-600 text-center">
            &copy; {new Date().getFullYear()} - {pageData.vendorName} {pageData.appName} {pageData.revision}
          </p>
        </div>
      </Overlay.Footer>
    </div>
  );
};

export default Footer; 